module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newsletter"
  }, [_c('h5', {
    staticClass: "newsletter__title"
  }, [_vm._v(_vm._s(_vm.content.title))]), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('form', {
    ref: "form",
    staticClass: "newsletter__form",
    class: _vm.formClasses,
    attrs: {
      "name": "newsletter-form",
      "action": "/",
      "method": "post",
      "netlify": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.send($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }],
    staticClass: "newsletter__input",
    attrs: {
      "id": "email",
      "name": "email",
      "type": "text",
      "autocomplete": "email",
      "placeholder": _vm.content.placeholder,
      "data-invalid": !_vm.valid
    },
    domProps: {
      "value": _vm._s(_vm.value)
    },
    on: {
      "focus": function($event) {
        _vm.valid = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.value = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button button--fill newsletter__submit",
    class: _vm.submitButton
  }, [_c('span', {
    staticClass: "button__bg"
  }, [_c('svg', {
    staticClass: "button__fold button__fold--c"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#button-fold-c"
    }
  })]), _vm._v(" "), _c('svg', {
    staticClass: "button__fold button__fold--b"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#button-fold-b"
    }
  })]), _vm._v(" "), _c('svg', {
    staticClass: "button__fold button__fold--a"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#button-fold-a"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "button__label"
  }, [_vm._v(_vm._s(_vm.content.submit))])]), _vm._v(" "), _c('h6', {
    staticClass: "newsletter__success"
  }, [_vm._v("Vous êtes maintenant abonné à l'infolettre!")])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-55f3129a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/generic/NewsletterForm.vue
// module id = 636
// module chunks = 1